export default __webpack_public_path__ + "static/media/US.db20d311.svg";